import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import NewsBox from '../../../../components/newsBox';

class FashionBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { fashionTopic, fashionTitle, fashionList, fashionBoxData, fashionListAd },
        } = this.props;

        return (
            <div id="fashionNewsList" className={styles.fashion_box}>
                <Chip id="50076" type="struct" title="时尚栏标题" groupName="时尚栏" content={fashionTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75093"
                    type="recommend"
                    title="时尚栏头条"
                    groupName="时尚栏"
                    content={fashionTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75094"
                    type="recommend"
                    title="时尚栏新闻列表"
                    groupName="时尚栏"
                    content={fashionList}
                    translate="handleNewsContentData">
                    <NewsList isList ad={fashionListAd} />
                </Chip>
                <Chip
                    id="75095"
                    type="recommend"
                    title="时尚栏新闻盒"
                    groupName="时尚栏"
                    content={fashionBoxData}
                    translate="handleNewsBoxData">
                    <NewsBox />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FashionBox);
